<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OJkGpB/tc-custom/9781497656543.jpg?1708746630879" alt="This image is the cover for the book Octagon Magic, The Magic Sequence"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Octagon Magic, The Magic Sequence
      </h1>
      <p class="bookDescription body article font2">
        <b>An orphan girl meets the inhabitants of the mysterious Octagon House—and discovers a portal to America’s past—from the Gandalf Grand Master of Fantasy.</b><br/><br/> Lorrie happens upon a strange and fascinating secret! Did a witch live in the eight-sided house? Was it haunted? There were lots of scary stories about the strange house—but none could match the secret Lorrie uncovered. One day, she climbed the high iron gate and escaped into the garden to save a kitten from some cruel boys—and met the mysterious lady of the house. The woman let Lorrie explore all the odd-shaped rooms. In one of them was a rocking horse and a large, eight-sided dollhouse—an exact miniature of the big house. The dollhouse was beautifully furnished—as if someone lived there! It drew Lorrie back into exciting adventures that she had to face with courage and daring!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andre Norton
      </h2>
      
      <p class="authorDescription body article">Andre Norton was one of the most popular science fiction and fantasy authors in the world. With series such as Time Traders, Solar Queen, Forerunner, Beast Master, Crosstime, and Janus, as well as many standalone novels, her tales of adventure have drawn countless readers to science fiction. Her fantasy novels, including the bestselling Witch World series, her Magic series, and many other unrelated novels, have been popular with readers for decades. Lauded as a Grand Master by the Science Fiction Writers of America, she is the recipient of a Life Achievement Award from the World Fantasy Convention. An Ohio native, Norton lived for many years in Winter Park, Florida, and died in March 2005 at her home in Murfreesboro, Tennessee.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?71fddbce